export default {
    REQUEST_SEARCH_RESULTS: 'SEARCH/REQUEST_SEARCH_RESULTS',
    STOP_REQUEST_SEARCH_RESULTS: 'SEARCH/STOP_REQUEST_SEARCH_RESULTS',
    RECEIVE_SEARCH_RESULTS: 'SEARCH/RECEIVE_SEARCH_RESULTS',
    HANDLE_SEARCH_RESULTS_ERROR: 'SEARCH/HANDLE_SEARCH_RESULTS_ERROR',
    ADD_SEARCH_RESULTS: 'SEARCH/ADD_SEARCH_RESULTS',
    LOCATION_CHANGE: 'SEARCH/ROUTER_DISPATCHED_ROUTE_CHANGE',
    UPDATE_ROUTING: 'SEARCH/UPDATE_ROUTING',
    SET_SINGLE_FILTER: 'SEARCH/SET_SINGLE_FILTER_VALUE',
    CHANGE_SORT_VALUE: 'SEARCH/CHANGE_SORT_VALUE',
    SET_ACTIVE_FILTER: 'SEARCH/SET_ACTIVE_FILTER',
    SET_ACTIVE_CATEGORY: 'SEARCH/SET_ACTIVE_CATEGORY',
    ADD_ITEM_ON_DISPLAY: 'SEARCH/ADD_ITEM_ON_DISPLAY',
    REMOVE_ITEM_ON_DISPLAY: 'SEARCH/REMOVE_ITEM_ON_DISPLAY'
};
